/**
 * 后台统一系统弹窗（替代 window.alert / window.confirm）。
 * 需在 App 根挂载 <AdminSystemDialog />。
 */

let handler = null
const queue = []

function flush() {
  if (!handler || !queue.length) return
  const job = queue[0]
  handler(job)
}

export function registerAdminDialogHandler(fn) {
  handler = typeof fn === 'function' ? fn : null
  flush()
}

function enqueue(spec) {
  return new Promise((resolve) => {
    queue.push({
      ...spec,
      resolve: (v) => {
        queue.shift()
        resolve(v)
        flush()
      },
    })
    flush()
  })
}

/** @param {string} message @param {{ title?: string, okText?: string }} [opts] */
export function adminAlert(message, opts = {}) {
  const text = message == null ? '' : String(message)
  return enqueue({
    mode: 'alert',
    title: opts.title || '提示',
    message: text,
    okText: opts.okText || '确定',
    cancelText: '',
  })
}

/** @param {string} message @param {{ title?: string, okText?: string, cancelText?: string }} [opts] @returns {Promise<boolean>} */
export function adminConfirm(message, opts = {}) {
  const text = message == null ? '' : String(message)
  const o = opts || {}
  return enqueue({
    mode: 'confirm',
    title: o.title || '请确认',
    message: text,
    okText: o.okText || '确定',
    cancelText: o.cancelText || '取消',
  }).then((v) => v === true)
}

/** @param {string} message @param {string|{ title?: string, okText?: string, cancelText?: string, defaultValue?: string, placeholder?: string }} [opts] @returns {Promise<string|null>} */
export function adminPrompt(message, opts = {}) {
  const text = message == null ? '' : String(message)
  // 兼容原 window.prompt(msg, defaultValue) 第二参为字符串
  const o = typeof opts === 'string' ? { defaultValue: opts } : opts || {}
  return enqueue({
    mode: 'prompt',
    title: o.title || '请输入',
    message: text,
    okText: o.okText || '确定',
    cancelText: o.cancelText || '取消',
    defaultValue: o.defaultValue == null ? '' : String(o.defaultValue),
    placeholder: o.placeholder || '',
  }).then((v) => (v === false || v == null ? null : String(v)))
}

/** 全局劫持浏览器原生 alert；confirm 请用 await adminConfirm（见各业务页替换） */
export function installAdminDialogWindowShims() {
  window.alert = (msg) => {
    void adminAlert(msg == null ? '' : String(msg))
  }
}
